import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-apkinstaller',
  templateUrl: './apkinstaller.component.html',
  styleUrls: ['./apkinstaller.component.css']
})
export class ApkinstallerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  downloadFile(){
    let link = document.createElement("a");
    link.download = "MemberAlly.apk";
    link.href = "assets/apk/MemberAlly.apk";
    link.click();
}

}
